// react
import { fromJS } from "immutable";
import React from "react";

import { faPlus, faRightLong, faTimes } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Button from "../../../../components/Button";
import SelectInput from "../../../../components/Inputs/SelectInput";
import TextInput from "../../../../components/Inputs/TextInput";
// components
import Spacer from "../../../../components/Spacer";

// dependencies
import PropTypes from "../../../../lib/prop-types";

// styles
import css from "../SftpSettings.module.scss";

const FieldMapping = (props) => {
	const {
		fieldMapOverrides,
		addFieldMapOverride,
		removeFieldMapOverride,
		updateFieldMapOverride,
		companyCustomFields,
	} = props;

	const handleChange = (value, index, type) => {
		if (type === "custom-field") {
			const existingOverride = fieldMapOverrides[index];
			const newOverride = {
				...existingOverride,
				performyard_custom_field_name: companyCustomFields.filter((field) => field.id === value)[0].name,
			};
			updateFieldMapOverride(index, newOverride);
		}

		if (type === "csv-field") {
			const existingOverride = fieldMapOverrides[index];
			const newOverride = {
				...existingOverride,
				csv_column_name: value,
			};
			updateFieldMapOverride(index, newOverride);
		}
	};

	return (
		<div className={css.inputWrapper}>
			<div className={css.modalDescription}>Custom Field Mapping (Optional)</div>
			<div className={css.moreDescription}>The first line of the synced CSV is interpreted as the header.</div>
			<div className={css.moreDescription}>
				By default, header values will be mapped to employee fields of the same name for transferring associated
				data.
			</div>
			<div className={css.moreDescription}>
				Create a mapping for all header values which differ in name from the associated employee fields.
			</div>
			{fieldMapOverrides.length > 0 ? (
				<div>
					<Spacer height={2} />
					<div className={css.moreDescription} style={{ float: "left", width: "50%", left: "12%" }}>
						Enter CSV Field
					</div>
					<div className={css.moreDescription} style={{ float: "right", width: "50%", left: "7%" }}>
						Select A PerformYard Custom Field
					</div>
					<Spacer height={2} />
				</div>
			) : (
				""
			)}
			{fieldMapOverrides.map((fieldMapper, ii) => (
				// eslint-disable-next-line react/no-array-index-key
				<div key={`${ii}-fieldMap`}>
					<div style={{ width: "90%", float: "left" }}>
						<div style={{ width: "45%", float: "left" }}>
							<div className={css.modalInput}>
								<Spacer height={0.05} />

								<TextInput
									maxLength={30}
									value={fieldMapper.csv_column_name}
									onChange={(val) => {
										handleChange(val, ii, "csv-field");
									}}
								/>
							</div>
						</div>
						<span
							style={{
								bottom: "-10px",
								position: "relative",
								left: "25px",
							}}
						>
							<FontAwesomeIcon icon={faRightLong} data-testid="right-long" />
						</span>
						<div style={{ width: "45%", float: "right" }}>
							<div className={css.modalInput}>
								<SelectInput
									value={{ label: fieldMapper.performyard_custom_field_name }}
									results={fromJS(
										companyCustomFields.map((customField) => ({
											id: customField.id,
											label: customField.name,
										}))
									)}
									onChange={(val) => {
										handleChange(val, ii, "custom-field");
									}}
									setFirstResult={false}
								/>
							</div>
						</div>
					</div>
					<div style={{ width: "9%", float: "right", top: "12px" }}>
						<span
							className={css.inputIcon}
							onClick={() => {
								removeFieldMapOverride(ii);
							}}
						>
							<FontAwesomeIcon icon={faTimes} data-testid="xmark" />
						</span>
					</div>
				</div>
			))}
			<div
				style={{
					width: "90%",
					display: "flex",
					justifyContent: "space-evenly",
				}}
			>
				<Button
					version={2}
					color="grey"
					style={{ width: "100%", marginTop: "10px" }}
					onClick={() => {
						addFieldMapOverride("", "");
					}}
				>
					{" "}
					<FontAwesomeIcon icon={faPlus} style={{ marginRight: "4px" }} data-testid="plus" /> Add CSV
					Mapping{" "}
				</Button>
			</div>
		</div>
	);
};

FieldMapping.propTypes = {
	fieldMapOverrides: PropTypes.array.isRequired,
	addFieldMapOverride: PropTypes.func.isRequired,
	removeFieldMapOverride: PropTypes.func.isRequired,
	updateFieldMapOverride: PropTypes.func.isRequired,
	companyCustomFields: PropTypes.array.isRequired,
};

export default FieldMapping;
